import Button, { ButtonProps } from "@/Button/Button";
import { iconButtonClasses } from "./IconButton.style";
import { ComponentProps, forwardRef } from "react";

export type IconButtonProps = ComponentProps<"button"> & ButtonProps & {};

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    const { children, className, ...rest } = props;
    return (
      <Button
        {...rest}
        ref={ref}
        className={iconButtonClasses({ class: className })}
      >
        {children}
      </Button>
    );
  }
);

export default IconButton;
